/* Copyright (c) 2017 Backpack Health LLC */

class BirthSex {

  static createFromId(birthSexList, id) {
    const data = birthSexList.filter((g) => (g.id === id))[0] || {};
    return new BirthSex(data);
  }

  constructor(birthSexData = {}) {
    this.data = birthSexData;
  }

  isIndeterminate() {
    return this.data.key === 'list.birth-sex.indeterminate';
  }

  messageKey() {
    return this.data.key ? `${this.data.key}.name` : '';
  }
}

export default BirthSex;
